import type { ReactNode } from "react";

type ConfirmationModalProps = {
    show: boolean;
    title?: string;
    message: string | ReactNode;
    onConfirm: () => void;
    onCancel: () => void;
    confirmLabel?: string;
    cancelLabel?: string;
    loading?: boolean;
    icon?: ReactNode | null;
};

const ConfirmationModal = ({
    show,
    title,
    message,
    onConfirm,
    onCancel,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    loading = false,
    icon = null,
}: ConfirmationModalProps) => {
    if (!show) return null;
    return (
        <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-30 tw-z-50">
            <div className="tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-bg-white tw-rounded-t-2xl tw-shadow-lg tw-px-8 tw-py-8 tw-flex tw-flex-col tw-items-center tw-max-w-md tw-mx-auto tw-min-h-[250px] tw-max-h-[80vh]">
                <div className="tw-mb-4 tw-flex tw-flex-col tw-items-center">
                    {icon && <span className="tw-text-5xl tw-mb-2">{icon}</span>}
                    {title && <div className="tw-text-xl tw-font-bold tw-mb-2 tw-opacity-70">{title}</div>}
                    <div className="tw-text-center tw-mb-1">{message}</div>
                </div>
                <div className="tw-flex tw-gap-4 tw-mt-2 tw-w-full">
                    <button
                        className="tw-flex-1 tw-bg-gray-100 tw-text-gray-700 tw-py-2 tw-rounded-lg tw-font-semibold hover:tw-bg-gray-200"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        className="tw-flex-1 tw-bg-[#EA4949] tw-text-white tw-py-2 tw-rounded-lg tw-font-semibold hover:tw-bg-red-700 disabled:tw-opacity-50"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? "Deleting..." : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
